// in code use it like base_url + lesson
// we do this because axios is already configured with the base url, so if you make an ajax request you never have to
// give the baseUrl to begin with.
// @formatter:off

class Routes {
    baseUrl() {
        return baseUrl;
    }

    // school
    school() {
        return '/school';
    }
    schoolsGet() {
        return '/school/get';
    }

    schoolsWithoutLessonModulesForOrganization() {
        return '/external/organization/schools/unlinked-schools'
    }
    schoolStore() {
        return '/school/store';
    }
    schoolCopy(id) {
        return '/school/copy/' + id;
    }
    schoolUpdate(id) {
        return '/school/update/' + id;
    }
    schoolHavePortfolio() {
        return this.school() + '/haveportfolio';
    }
    schoolHaveQuest() {
        return this.school() + '/havequest';
    }
    schoolHaveInternship() {
        return this.school() + '/haveinternship';
    }
    schoolGetUsers() {
        return this.school() + '/users';
    }
    schoolSelectUser(id) {
        return this.school() + '/select/user/' + id;
    }

    schoolAccounts() {
        return this.school() + '/accounts';
    }
    schoolGetAccounts() {
        return this.school() + '/accounts/get';
    }
    schoolRedirectAccount(id) {
        return this.school() + '/select/user/' + id;
    }

    schoolAccountAdd() {
        return this.school() + '/accounts/store';
    }
    schoolAccountImport() {
        return this.schoolAccounts() + '/import';
    }
    schoolAccountImportSettings(id) {
        return this.schoolAccountImport() + '/' + id + '/settings';
    }
    schoolAccountImportValidate(id) {
        return this.schoolAccountImport() + '/' + id + '/validate';
    }

    schoolAccountUser(id) {
        return '/school/accounts/update/' + id;
    }
    schoolAccountUserDelete(id) {
        return '/school/accounts/delete/' + id;
    }

    schoolGetLaslocations() {
        return this.school() + '/laslocations';
    }

    // school settings
    digistudiesStore(id) {
        return '/school/settings/digistudies/' + id;
    }
    digistudiesDestroy(id, access_id) {
        return '/school/settings/digistudies/' + id + '/delete/' + access_id;
    }
    addressUpdate() {
        return '/school/updateaddress';
    }

    //student
    digistudiesStudentStore(id) {
        return '/school/settings/digistudies/student/' + id;
    }
    digistudiesStudentDestroy(id, access_id) {
        return '/school/settings/digistudies/student/' + id + '/delete/' + access_id;
    }

    //teacher
    digistudiesTeacherStore(id) {
        return '/school/settings/digistudies/teacher/' + id;
    }
    digistudiesTeacherDestroy(id, access_id) {
        return '/school/settings/digistudies/teacher/' + id + '/delete/' + access_id;
    }

    //groups
    digistudiesGroupStore(id) {
        return '/school/settings/digistudies/group/' + id;
    }
    digistudiesGroupDestroy(id, access_id) {
        return '/school/settings/digistudies/group/' + id + '/delete/' + access_id;
    }

    //las groups
    digistudiesLasGroupStore(id) {
        return '/school/settings/digistudies/lasgroup/' + id;
    }
    digistudiesLasGroupDestroy(id, access_id) {
        return '/school/settings/digistudies/lasgroup/' + id + '/delete/' + access_id;
    }

    //las main groups
    digistudiesLasMainGroupStore(id) {
        return '/school/settings/digistudies/lasmaingroup/' + id;
    }
    digistudiesLasMainGroupDestroy(id, access_id) {
        return '/school/settings/digistudies/lasmaingroup/' + id + '/delete/' + access_id;
    }

    schoolSettingsUpdate() {
        return '/school/updatesetting';
    }

    profileChoiceCreate(id) {
        return '/profilechoice/' + id;
    }

    managementProfileChoice() {
        return '/management/profilechoice';
    }

    managementProfileGetAllStudents() {
        return '/management/profile/get-all-students';
    }
    managementCustomForm() {
        return '/management/customform';
    }
    managementCustomFormDownload(id) {
        return '/management/customform/' + id + '/download';
    }
    managementCustomFormDownloadPDF(id) {
        return '/management/customform/' + id + '/download/pdf';
    }
    managementCustomFormPublicUrl(id, hash) {
        return this.baseUrl() + '/customform/' + id + '?t=' + hash;
    }

    managementProfileChoiceSurvey() {
        return '/management/profilechoice/survey';
    }
    managementProfileChoiceSurveyShow(id) {
        return '/management/profilechoice/survey/' + id;
    }
    managementProfileChoiceSurveyDownload(id) {
        return '/management/profilechoice/survey/' + id + '/download';
    }
    managementProfileChoiceSurveyRemove(id) {
        return '/management/profilechoice/survey/' + id;
    }

    //group pair
    groupPair() {
        return '/grouppair';
    }

    groupPairStatus(group_id) {
        return this.groupPair() + '/group/' + group_id;
    }
    groupPairStore() {
        return this.groupPair();
    }
    groupPairUpdate(id) {
        return this.groupPair() + '/' + id;
    }

    groupPairUpdateStatus(group_id) {
        return '/grouppair/update/' + group_id + '/status';
    }

    groupPairTeacherAdd() {
        return '/grouppair/groupteacher';
    }

    groupPairTeachersGet(group_id) {
        return '/grouppair/teachers/' + group_id;
    }
    groupPairTeachersUpdate(id) {
        return '/grouppair/teachers/update/' + id;
    }

    groupPairTeacherUpdateMax(id) {
        return '/grouppair/teacher/' + id;
    }
    groupPairTeacherDelete(id) {
        return '/grouppair/teacher/' + id;
    }
    groupPairTeacherCheck(group_id) {
        return '/grouppair/teacher/check/' + group_id;
    }

    groupPairStudentDelete(id) {
        return '/grouppair/student/' + id;
    }
    groupPairStudentAdd() {
        return '/grouppair/student';
    }

    groupPairOptionsStore() {
        return '/group/settings/grouppair';
    }
    groupPairOptionsUpdate(id) {
        return '/group/settings/grouppair/' + id;
    }
    groupPairOptionsRestore(id) {
        return '/group/settings/grouppair/' + id + '/restore';
    }

    groupPairLasGroups(group_id) {
        return '/grouppair/' + group_id + '/lasgroups';
    }
    groupPairLasMainGroups(group_id) {
        return '/grouppair/' + group_id + '/lasmaingroups';
    }

    groupPairDownloadOverview(group_id) {
        return '/grouppair/' + group_id + '/download/overview';
    }
    groupPairDownloadStudentsLeft(group_id) {
        return '/grouppair/' + group_id + '/download/studentsleft';
    }

    groupPairReopen(group_id) {
        return '/grouppair/' + group_id + '/reopen';
    }

    groupPairImport(groupId) {
        return '/grouppair/' + groupId + '/import';
    }
    groupPairImportSettings(groupId, importId) {
        return this.groupPairImport(groupId) + '/' + importId + '/settings';
    }
    groupPairImportValidate(groupId, importId) {
        return this.groupPairImport(groupId) + '/' + importId + '/validate';
    }
    groupPairImportExistingUsers(groupId, importId) {
        return this.groupPairImport(groupId) + '/' + importId + '/existingusers';
    }

    groupPairTeacherImport(groupId) {
        return this.groupPairImport(groupId) + '/teacher';
    }
    groupPairImportTeacherSettings(groupId, importId) {
        return this.groupPairTeacherImport(groupId) + '/' + importId + '/settings';
    }
    groupPairImportTeacherValidate(groupId, importId) {
        return this.groupPairTeacherImport(groupId) + '/' + importId + '/validate';
    }
    groupPairImportTeacherExistingUsers(groupId, importId) {
        return this.groupPairTeacherImport(groupId) + '/' + importId + '/existingusers';
    }

    //beheer

    skillAddRubric() {
        return '/skilltree/add/rubric';
    }
    skillDeleteRubric(id) {
        return '/skilltree/rubric/' + id;
    }
    skillEditRubric(id) {
        return '/skilltree/rubric/' + id;
    }

    managementProfile() {
        return '/management/profile';
    }
    managementModule() {
        return '/management/modules';
    }

    managementModulePeriod() {
        return this.managementModule() + '/period/';
    }

    managementModulesPeriod(id) {
        return this.managementModulePeriod() + id;
    }

    managementProfileSettings() {
        return '/management/profile-settings';
    }

    managementStatistics() {
        return '/management/statistics';
    }
    managementDigistudies() {
        return '/management/digistudies';
    }
    managementSchoolData() {
        return '/management/school';
    }
    managementSchoolAttachments() {
        return '/management/settings';
    }

    profileCategoryAdd() {
        return '/profilecategory';
    }
    profileCategoryUpdate(id) {
        return '/profilecategory/' + id;
    }
    profileCategoryDelete(id) {
        return '/profilecategory/' + id;
    }

    updateProfileCategoryDescription() {
        return '/school/updateprofilecategorydescription';
    }

    profileManagementAddTeacher() {
        return '/profile/management';
    }
    profileManagementDeleteTeacher(id) {
        return '/profile/management/' + id;
    }

    //skills
    skills() {
        return '/skills';
    }
    updateSkills(id) {
        return '/skills/update/' + id;
    }

    skillManagementAddTeacher() {
        return '/skill/management';
    }
    skillManagementDeleteTeacher(id) {
        return '/skill/management/' + id;
    }

    skillTreeEdit(id) {
        return '/skilltree/' + id;
    }
    skillTreeStore() {
        return '/skilltree/store';
    }
    skillTreeUpdate(id) {
        return '/skilltree/update/' + id;
    }
    skillTreeDelete(id) {
        return '/skilltree/delete/' + id;
    }

    skillsStore() {
        return 'skill/store';
    }
    skillsUpdate(id) {
        return 'skill/update/' + id;
    }
    skillsDelete(id) {
        return 'skill/delete/' + id;
    }

    skillSkillTreeStore(skill_tree_id) {
        return '/skilltree/' + skill_tree_id + '/skill/parent';
    }
    skillSkillTreeupdate(id) {
        return '/skilltree/skill/update/' + id;
    }
    skillSkillTreeDelete(id) {
        return '/skilltree/skill/delete/' + id;
    }

    skillSkillTreeDrag(id) {
        return '/skilltree/skill/update/drag/' + id;
    }

    skillRubricStore() {
        return '/skill/rubric';
    }
    skillRubricUpdate(id) {
        return '/skill/rubric/' + id;
    }
    skillRubricDelete(id) {
        return '/skill/rubric/delete/' + id;
    }

    defaultSkillTreeEdit(id) {
        return '/default/skilltree/' + id;
    }
    getDefaultSkillTrees() {
        return '/default/skills';
    }
    defaultSkillTreeStore() {
        return '/default/skills';
    }
    defaultSkillTreeUpdate(id) {
        return '/default/skills/' + id;
    }
    defaultSkillTreeDelete(id) {
        return '/default/skills/' + id;
    }
    defaultSkillTreeCopy(id) {
        return '/default/copy/' + id;
    }

    // rubric
    rubric() {
        return '/rubric';
    }
    createRubric() {
        return this.rubric() + '/create';
    } // word niet gebruikt. oude huisstijl
    editRubric(id) {
        return this.rubric() + '/' + id;
    }
    storeRubric() {
        return this.rubric() + '/store';
    } // word niet gebruikt.
    updateRubric(id) {
        return this.rubric() + '/update/' + id;
    }
    deleteRubric(id) {
        return this.rubric() + '/delete/' + id;
    }

    addRubricSection(id) {
        return this.rubric() + '/' + id + '/section/add';
    }
    updateRubricSection(id) {
        return this.rubric() + '/' + id + '/section/update';
    }
    deleteRubricSection(id) {
        return this.rubric() + '/' + id + '/section/delete';
    }

    addRubricColumn(id) {
        return this.rubric() + '/section/' + id + '/column/add';
    }
    updateRubricColumn(id) {
        return this.rubric() + '/section/' + id + '/column/update';
    }
    deleteRubricColumn(id) {
        return this.rubric() + '/section/' + id + '/column/delete';
    }

    addRubricRow(id) {
        return this.rubric() + '/section/' + id + '/row/add';
    }
    updateRubricRow(id) {
        return this.rubric() + '/section/' + id + '/row/update';
    }
    deleteRubricRow(id) {
        return this.rubric() + '/section/' + id + '/row/delete';
    }

    addRubricCell(id) {
        return this.rubric() + '/section/cell/add';
    }
    updateRubricCell(id) {
        return this.rubric() + '/section/cell/' + id + '/update';
    }
    deleteRubricCell(id) {
        return this.rubric() + '/section/cell/' + id + '/delete';
    }

    rubricFormShow(form_id) {
        return this.rubric() + '/form/' + form_id;
    }
    rubricFormEdit(form_id) {
        return this.rubric() + '/form/' + form_id + '/edit';
    }
    rubricFormEditSurvey(rubric_survey_id) {
        return this.rubric() + '/survey/' + rubric_survey_id + '/form/edit/multiple';
    }

    updateRubricAnswer(id) {
        return this.rubric() + '/answer/' + id + '/update';
    }

    showForm(form_id) {
        return this.rubric() + '/form/' + form_id;
    }
    rubricFormModal(form_id) {
        return this.rubric() + '/form/' + form_id + '/modal';
    }

    getSurveys() {
        return this.rubric() + '/survey';
    }
    getRubricSurvey() {
        return this.getSurveys() + '/get';
    }
    addRubricSurvey() {
        return this.getSurveys() + '/store';
    }
    deleteRubricSurvey(id) {
        return this.getSurveys() + '/' + id;
    }

    showRubricSurvey(id) {
        return this.getSurveys() + '/' + id;
    }

    rubricSurveyUserShow(rubric_survey_user_id) {
        return this.getSurveys() + '/user/' + rubric_survey_user_id + '/show';
    }

    getRubricUserPotentialPeers(rubric_survey_user_id, rubricType) {
        return this.getSurveys() + '/user/' + rubric_survey_user_id + '/potential-peers/' + rubricType;
    }
    rubricSurveyUserPeerStore() {
        return this.getSurveys() + '/user/peer';
    }
    rubricSurveyUserPeerRemove(id) {
        return this.rubricSurveyUserPeerStore() + '/' + id;
    }

    rubricSurveyUserPeerStudentStore() {
        return this.rubricSurveyUserPeerStore() + '/student';
    }

    getAssignmentRubrics() {
        return this.rubric() + '/assignment';
    }
    assignmentRubricUserPeerStore() {
        return this.getAssignmentRubrics() + '/user/peer';
    }
    assignmentRubricUserPeerStudentStore() {
        return this.assignmentRubricUserPeerStore() + '/student';
    }

    submitSkillsForAssignmentRubric() {
        return this.getAssignmentRubrics() + '/partner/skill-tree';
    }

    rubricSurveyStudents(rubric_survey_id) {
        return this.getSurveys() + '/students/' + rubric_survey_id;
    }
    rubricSurveyStudentsAdd(rubric_survey_id) {
        return this.rubricSurveyStudents(rubric_survey_id);
    }

    rubricSurveyStudentsDelete(rubric_survey_user_id) {
        return this.rubricSurveyStudents(rubric_survey_user_id);
    }

    rubricSurveyUserEdit(rubric_survey_user_id) {
        return this.getSurveys() + '/user/' + rubric_survey_user_id + '/edit';
    }

    //modules
    module() {
        return '/module';
    }
    moduleDate() {
        return this.module() + '/date';
    }

    moduleRubricSurveyStore() {
        return this.module() + '/rubric/survey';
    }

    moduleDateRubricSurvey() {
        return this.moduleDate() + '/rubric/survey';
    }
    moduleDateRubricSurveyStore() {
        return this.moduleDateRubricSurvey();
    } // NIET GEBRUIKT.
    moduleDateRubricSurveyDelete(id) {
        return this.moduleDateRubricSurvey() + '/' + id;
    } // OOK NIET GEBRUIKT.

    updateModuleDates(id) {
        return '/modules/dates/' + id;
    }
    addModule() {
        return '/module';
    }
    updateModule(id) {
        return '/module/' + id;
    }
    deleteModule(id) {
        return '/module/' + id;
    }

    moduleManagementAddTeacher() {
        return '/module/management';
    }
    moduleManagementDeleteTeacher(id) {
        return '/module/management/' + id;
    }

    moduleLasGroupAdd() {
        return '/module/management/lasgroup';
    }
    moduleLasGroupDelete(id, module_id) {
        return '/module/management/lasgroup/' + id + '/' + module_id;
    }

    moduleLasMainGroupAdd() {
        return '/module/management/lasmaingroup';
    }
    moduleLasMainGroupDelete(id, module_id) {
        return '/module/management/lasmaingroup/' + id + '/' + module_id;
    }

    moduleUsers(id) {
        return '/module/user/' + id;
    }
    addModuleUser() {
        return '/module/user';
    }
    moduleUserUpdate(id) {
        return '/module/user/motivation/' + id;
    }
    deleteModuleUser(id) {
        return '/module/user/' + id;
    }

    addModuleTag() {
        return '/module/tag';
    }
    updateModuleTag(id) {
        return '/module/tag/' + id;
    }
    deleteModuleTag(id) {
        return '/module/tag/' + id;
    }
    showModules() {
        return '/modules/show';
    }
    moduleGetUsers() {
        return '/module/users';
    }
    moduleUserStore(user_id) {
        return '/module/user/' + user_id;
    }
    showUserModules(id) {
        return '/module/show/user/' + id;
    }
    showModulesTabs(id) {
        return '/modules/show/' + id;
    }

    modulesDownload() {
        return '/modules/downloads';
    }
    moduleDownload(id) {
        return '/module/download/' + id;
    }

    modulesExport() {
        return '/modules/export';
    }

    modulePeriods() {
        return this.managementModule() + '/period';
    }
    modulePeriodsUpdate(id) {
        return this.modulePeriods() + '/' + id;
    }
    modulePeriodIndex(id) {
        return this.modulePeriods() + '/' + id;
    }

    getModules() {
        return '/modules';
    }
    showModule(id) {
        return '/modules/show/' + id;
    }

    // group
    group() {
        return '/group';
    }
    groupAll() {
        return this.group() + '/all';
    }
    groupMainPerSeason(season_id) {
        return this.group() + '/all/main/season/' + season_id;
    }
    groupSubGroupPerSeason(group_id, season_id) {
        return this.group() + '/' + group_id + '/all/childs/season/' + season_id;
    }
    groupTeacherChange(id) {
        return this.group() + '/teacher/' + id;
    }
    groupUpdate(id) {
        return this.group() + '/' + id;
    }
    groupDelete(id) {
        return this.group() + '/' + id;
    }
    groupShow(id) {
        return this.group() + '/' + id;
    }
    groupUploadPaperBlueprint(id) {
        return this.group() + '/' + id + '/editor/upload/paper';
    }
    groupUploadActionplanBlueprint(id) {
        return this.group() + '/' + id + '/editor/upload/actionplanblueprint';
    }
    groupUploadPowerpointBlueprint(id) {
        return this.group() + '/' + id + '/editor/upload/powerpoint';
    }

    groupPossibleInviteStudents(id) {
        return this.group() + '/getpossibleinvitestudents/' + id;
    }

    groupCustomEditorFile(group_id) {
        return this.group() + '/' + group_id + '/custom-editor-file';
    }
    storeGroupCustomEditorFile(group_id) {
        return this.groupCustomEditorFile(group_id) + '/create';
    }
    updateGroupCustomEditorFile(group_id, group_custom_editor_file_id) {
        return this.groupCustomEditorFile(group_id) + '/update/' + group_custom_editor_file_id;
    }
    deleteGroupCustomEditorFile(group_id, group_custom_editor_file_id) {
        return this.groupCustomEditorFile(group_id) + '/delete/' + group_custom_editor_file_id;
    }
    groupUploadCustomEditorFile(group_id, group_custom_editor_file_id) {
        return this.groupCustomEditorFile(group_id) + '/store-blueprint/' + group_custom_editor_file_id;
    }

    groupInviteStudentsLeft(id) {
        return this.group() + '/getinvitestudentsleft/' + id;
    }
    groupInviteStudentDelete(id) {
        return this.group() + '/deleteinviteuser/' + id;
    }
    groupInvitesCheck(group_id) {
        return this.group() + '/grouppair/' + group_id;
    }
    groupInviteStudentAdd() {
        return this.group() + '/addinviteuser';
    }
    groupOpenCloseAll(id) {
        return this.group() + '/opencloseall/' + id;
    }
    groupCustomEditorFileInEditor(group_id, group_custom_editor_file_id) {
        return this.groupCustomEditorFile(group_id) + '/' + group_custom_editor_file_id + '/in-editor';
    }
    groupStudents(id) {
        return this.group() + '/students/' + id;
    }

    groupPossibleInviteConnectedStudents(id) {
        return this.group() + '/getpossibleinviteconnectedstudents/' + id;
    }
    groupBannerCreate(id) {
        return this.group() + '/' + id + '/banner';
    }
    groupBannerRemove(id, banner_id) {
        return this.group() + '/' + id + '/banner/delete/' + banner_id;
    }
    groupBannerUpdate(id, banner_id) {
        return this.group() + '/' + id + '/banner/update/' + banner_id;
    }
    groupHavePortfolio(school_id) {
        return this.group() + '/haveportfolio/' + school_id;
    }
    groupHaveQuest(school_id) {
        return this.group() + '/havequest/' + school_id;
    }

    groupHaveInternshipPortfolio(school_id) {
        return this.group() + '/haveInternshipportfolio/' + school_id;
    }
    groupLasGroup(group_id, las_group_id) {
        return this.group() + '/' + group_id + '/las/group/' + las_group_id;
    }
    groupLasMainGroup(group_id, las_main_group_id) {
        return this.group() + '/' + group_id + '/las/maingroup/' + las_main_group_id;
    }

    groupLasCreateProjects(group_id) {
        return this.group() + '/' + group_id + '/las/createprojects';
    }
    groupLasCreateGroupStudents(group_id) {
        return this.group() + '/' + group_id + '/las/groupstudents';
    }

    groupLasShowChanges(group_id) {
        return this.group() + '/' + group_id + '/las/getchanges';
    }

    groupFileUpload(group_id) {
        return this.group() + '/' + group_id + '/files/create';
    }
    groupFileRemove(group_id, file_id) {
        return this.group() + '/' + group_id + '/files/delete/' + file_id;
    }
    groupFileEdit(group_id, file_id) {
        return this.group() + '/' + group_id + '/files/edit/' + file_id;
    }

    groupMessageCreate(group_id) {
        return this.group() + '/' + group_id + '/messages/create';
    }
    groupMessageUpdate(group_id) {
        return this.group() + '/' + group_id + '/messages/update';
    }
    groupMessageRemove(group_id, message_id) {
        return this.group() + '/' + group_id + '/messages/delete/' + message_id;
    }
    groupMessageUnreadRemove(group_id) {
        return this.group() + '/' + group_id + '/messages/unread';
    }
    groupAgendaCreate(group_id) {
        return this.group() + '/' + group_id + '/agenda/create';
    }
    groupAgendaUpdate(group_id, agenda_item_id) {
        return this.group() + '/' + group_id + '/agenda/update/' + agenda_item_id;
    }
    groupAgendaRemove(group_id, agenda_item_id) {
        return this.group() + '/' + group_id + '/agenda/delete/' + agenda_item_id;
    }
    groupGetUsers(group_id) {
        return this.group() + '/' + group_id + '/users/get';
    }
    groupGetSchoolUsers(group_id) {
        return this.group() + '/' + group_id + '/schoolusers';
    }
    groupGetSchoolStudentsLeft(group_id) {
        return this.group() + '/' + group_id + '/schoolstudentsleft';
    }
    groupUpdateCoordinators(groupId) {
        return this.group() + '/' + groupId + '/coordinators';
    }

    groupOptionsStatusUpdate(group_id) {
        return this.group() + '/updateoptionstatus/' + group_id;
    }

    groupPowerpoint(group_id) {
        return this.group() + '/' + group_id + '/editor/edit/powerpoint';
    }
    groupActionPlan(group_id) {
        return this.group() + '/' + group_id + '/editor/edit/actionplan';
    }
    groupBluePrintUrl(group_id) {
        return this.group() + '/' + group_id + '/editor/edit';
    }

    groupSetPageRights(group_id) {
        return this.group() + '/' + group_id + '/setpagerights';
    }

    getLasGroups(group_id) {
        return this.las() + '/groups';
    }
    getLasMainGroups(group_id) {
        return this.las() + '/main-groups';
    }

    groupApproveAll(group_id) {
        return this.group() + '/' + group_id + '/approveallmagazines';
    }

    groupCreate() {
        return this.group() + '/create';
    }
    groupRestore(group_id) {
        return this.group() + '/' + group_id + '/restore';
    }

    groupRubricSurveyStore() {
        return this.group() + '/rubric/survey';
    }
    groupRubricSurveyAvailableUsers(id) {
        return this.group() + '/rubric/survey/users/' + id;
    }
    getPortfolioByGroupId(id) {
        return this.group() + '/' + id + '/getportfolios';
    }
    groupShowGroupPair(id) {
        return this.group() + '/grouppair/' + id;
    }
    getGroupChildGroupPairStatus(id) {
        return this.group() + '/' + id + '/grouppair/status';
    }
    getPortfolioAnswersForGroup(groupId) {
        return this.group() + '/' + groupId + '/portfolio-answers';
    }
    getPortfolioResultsForGroup(groupId) {
        return this.group() + '/' + groupId + '/portfolio-results';
    }

    createSubGroup(id) {
        return this.group() + '/' + id + '/subgroup';
    }

    // invites
    invite() {
        return '/invite';
    }

    inviteSave() {
        return this.invite() + '/save';
    }

    inviteUploadFile(id) {
        return '/invite/create/' + id + '/upload';
    }

    // project
    project() {
        return '/project';
    }

    projectShow(projectId) {
        return this.project() + '/' + projectId;
    }
    projectDelete(id) {
        return this.project() + '/' + id;
    }
    projectsByGroupId(id) {
        return this.project() + '/group/' + id;
    }
    downloadProjectsByGroupId(id, byStudent) {
        return this.project() + '/group/' + id + '/download/' + byStudent;
    }

    projectGetUsers(project_id) {
        return this.project() + '/' + project_id + '/users/get';
    }
    projectAddUser() {
        return this.project() + '/adduser';
    }
    projectRemoveUser() {
        return this.project() + '/deleteuser';
    }
    projectUpdateCourses(id) {
        return this.project() + '/' + id + '/updateCourses';
    }
    projectDeleteCourses(id) {
        return this.project() + '/' + id + '/deleteCourses';
    }
    projectMessages(project_id) {
        return this.project() + '/' + project_id + '/messages';
    }
    projectMessageCreate(project_id) {
        return this.project() + '/' + project_id + '/messages/create';
    }
    projectMessageUpdate(project_id) {
        return this.project() + '/' + project_id + '/messages/update';
    }
    projectMessageRemove(project_id, message_id) {
        return this.project() + '/' + project_id + '/messages/' + message_id + '/delete';
    }

    projectDeleteUnreadMessage(id) {
        return this.project() + '/' + id + '/unreadmessages';
    }

    projectChangeGroup(id, group_id) {
        return this.project() + '/change-group/' + id + '/' + group_id;
    }
    projectTeacherChangeGroup(id, group_id) {
        return this.project() + '/change-group/teacher/' + id + '/' + group_id;
    }

    setProjectDeadline(id) {
        return this.project() + '/set-project-deadline/' + id;
    }

    // students
    rubricSurvey() {
        return 'rubric/survey';
    }

    studentsProfiles() {
        return 'students/profiles';
    }

    redirectLasGroupCenter() {
        return 'students/las-groups';
    }
    studentsInvites() {
        return 'students/invites';
    }

    // Presentations
    presentation() {
        return '/presentation';
    }

    presentationFolder() {
        return this.presentation() + '/folder';
    }

    presentationFolderUpdate(folder_id) {
        return this.presentationFolder() + '/' + folder_id;
    }

    presentationFolderDelete(folder_id) {
        return this.presentationFolder() + '/' + folder_id;
    }

    presentationShow(presentation_id) {
        return this.presentation() + '/' + presentation_id;
    }

    presentationEdit(presentation_id) {
        return this.presentation() + '/' + presentation_id + '/edit';
    }

    presentationRemoveListItem(listItemId) {
        return this.presentation() + '/list-item/' + listItemId;
    }

    presentationStepOrder() {
        return this.presentation() + '/step/order';
    }

    presentationSlideOrder() {
        return this.presentation() + '/slide-order';
    }

    presentationAddStep() {
        return this.presentation() + '/step/store';
    }

    presentationEditStep() {
        return this.presentation() + '/step/update';
    }

    presentationRemoveStep(stepId) {
        return this.presentation() + '/step/' + stepId;
    }

    presentationSlide() {
        return this.presentation() + '/slide/';
    }

    presentationSlideUpdate(id) {
        return this.presentationSlide() + id;
    }

    presentationSlideDelete(id) {
        return this.presentationSlide() + id;
    }

    presentationSlideListItemStore(id) {
        return this.presentationSlideUpdate(id) + '/store-list-item';
    }

    presentationSlideUpdateList(slide_id) {
        return this.presentationSlideUpdate(slide_id) + '/update-list';
    }

    presentationCopy(id) {
        return this.presentation() + '/' + id + '/copy';
    }

    presentationDelete(id) {
        return this.presentation() + '/' + id;
    }

    //log
    log() {
        return 'log';
    }
    logEdit(id) {
        return this.log() + '/edit/' + id;
    }

    // paper
    paper() {
        return '/paper';
    }
    paperShow(id) {
        return this.baseUrl() + this.paper() + '/' + id;
    }
    paperDeleteUnreadMessages(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/unreadmessages';
    }
    paperUpload(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/upload';
    }
    paperActionplanUpload(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/actionplan/upload';
    }
    paperPresentationUpload(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/presentation/upload';
    }
    paperVersionDownload(id, version) {
        return this.baseUrl() + this.paper() + '/' + id + '/download/' + version;
    }
    paperActionPlanVersionDownload(id, version) {
        return this.baseUrl() + this.paper() + '/actionplan/' + id + '/download/' + version;
    }
    paperPowerpointVersionDownload(id, version) {
        return this.baseUrl() + this.paper() + '/powerpoint/' + id + '/download/' + version;
    }
    paperOrder(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/order';
    }
    paperCourseAdd(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/addcourse';
    }
    paperCourseDelete(p_id, c_id) {
        return this.baseUrl() + this.paper() + '/' + p_id + '/deletecourse/' + c_id;
    }
    paperCoursesGet(id) {
        return this.baseUrl() + this.paper() + '/' + id + '/getcourses';
    }

    paperCalendarDelete(project_id, messageId) {
        return 'paper/' + project_id + '/agenda/delete/' + messageId;
    }

    paperEditorEdit(project_id) {
        return this.paper() + '/' + project_id + '/editor/edit';
    }
    paperEditorDownload(project_id) {
        return this.paper() + '/' + project_id + '/download';
    }
    paperEditorRead(project_id) {
        return this.paper() + '/' + project_id + '/editor/read';
    }
    paperEditorActionPlanEdit(project_id) {
        return this.paper() + '/' + project_id + '/actionplan/edit';
    }
    paperEditorActionPlanDownload(project_id) {
        return this.paper() + '/' + project_id + '/actionplan/download';
    }
    paperEditorActionPlanRead(project_id) {
        return this.paper() + '/' + project_id + '/actionplan/read';
    }
    paperEditorPowerpointEdit(project_id) {
        return this.paper() + '/' + project_id + '/powerpoint/edit';
    }
    paperEditorPresentationDownload(project_id) {
        return this.paper() + '/' + project_id + '/presentation/download';
    }

    projectCustomEditorFileEdit(project_id, group_custom_editor_file_id) {
        return '/project/' + project_id + '/custom-editor-file/' + group_custom_editor_file_id + '/edit';
    }
    projectCustomEditorFileRead(project_id, group_custom_editor_file_id) {
        return '/project/' + project_id + '/custom-editor-file/' + group_custom_editor_file_id + '/read';
    }
    projectCustomEditorFileDownload(project_id, group_custom_editor_file_id) {
        return '/project/' + project_id + '/custom-editor-file/' + group_custom_editor_file_id + '/download';
    }
    projectCustomEditorFileUpload(project_id, group_custom_editor_file_id) {
        return '/project/' + project_id + '/custom-editor-file/' + group_custom_editor_file_id + '/upload';
    }

    paperEditorDelete(editor_file_id) {
        return this.paper() + '/file/' + editor_file_id;
    }
    // portfolio
    portfolio() {
        return '/portfolio';
    }

    portfolioShow(id) {
        return this.portfolio() + '/' + id;
    }

    portfolioDeleteUnreadMessage(id) {
        return this.portfolio() + '/' + id + '/unreadmessages';
    }

    portfolioRating() {
        return this.portfolio() + '/rating';
    }

    portfolioRatingUpdate() {
        return this.portfolioRating() + '/update';
    }

    portfolioCategoryRating() {
        return this.portfolioRating() + '/category';
    }
    portfolioCategoryRatingUpdate() {
        return this.portfolioCategoryRating() + '/update';
    }

    portfolioAssignmentRating() {
        return this.portfolioRating() + '/assignment';
    }
    portfolioAssignmentRatingUpdate() {
        return this.portfolioAssignmentRating() + '/update';
    }

    portfolioSubAssignmentRating() {
        return this.portfolioRating() + '/subassignment';
    }
    portfolioSubAssignmentRatingUpdate() {
        return this.portfolioSubAssignmentRating() + '/update';
    }

    portfolioRatingResult() {
        return this.portfolioRating() + '/result';
    }
    portfolioRatingResultUpdate() {
        return this.portfolioRatingResult() + '/update';
    }
    portfolioEdit(id) {
        return this.portfolio() + '/edit/' + id;
    }

    portfolioCategoryRestore(portfolioId) {
        return this.portfolioEdit(portfolioId) + '/restore-category';
    }
    portfolioDeletedCategories(portfolioId) {
        return this.portfolioEdit(portfolioId) + '/deleted-categories';
    }

    portfolioCategoryToggleWorldmap(portfolioId, groupId) {
        return this.portfolioEdit(portfolioId) + '/' + groupId + '/toggle-worldmap';
    }

    portfolioAssignmentRestore(portfolioId, categoryId) {
        return this.portfolioEdit(portfolioId) + '/category/' + categoryId + '/restore-assignment';
    }

    portfolioDeletedAssignments(portfolioId, categoryId) {
        return this.portfolioEdit(portfolioId) + '/category/' + categoryId + '/deleted-assignments';
    }

    // quest
    quest(id) {
        return '/quest/' + id;
    }
    questEdit(id) {
        return '/quest/edit/' + id;
    }
    questRapport(id) {
        return '/quest/rapport/' + id;
    }

    questEditName(id) {
        return this.questEdit(id) + '/name';
    }
    questEditDescription(id) {
        return this.questEdit(id) + '/description';
    }
    questEditBannerUpload(id) {
        return this.questEdit(id) + '/banner/upload';
    }
    questEditBannerDelete(id) {
        return this.questEdit(id) + '/banner/delete';
    }

    questEditDeadlineSettings(id) {
        return this.questEdit(id) + '/deadline/settings';
    }
    questEditDeadlineAdd(id) {
        return this.questEdit(id) + '/deadline/add';
    }
    questEditDeadlineEdit(id) {
        return this.questEdit(id) + '/deadline/edit';
    }
    questEditDeadlineDelete(id, d_id) {
        return this.questEdit(id) + '/deadline/delete/' + d_id;
    }

    questEditSkillAdd(id) {
        return this.questEdit(id) + '/skill/add';
    }
    questEditSkillEdit(id) {
        return this.questEdit(id) + '/skill/edit';
    }
    questEditSkillDelete(id, s_id) {
        return this.questEdit(id) + '/skill/delete/' + s_id;
    }

    questEditLevelAdd(id) {
        return this.questEdit(id) + '/level/add';
    }
    questEditLevelEdit(id) {
        return this.questEdit(id) + '/level/edit';
    }
    questEditLevelDelete(id, l_id) {
        return this.questEdit(id) + '/level/delete/' + l_id;
    }
    questEditLevelOrder(id) {
        return this.questEdit(id) + '/level/order';
    }

    questEditCategoryAdd(id) {
        return this.questEdit(id) + '/category/add';
    }
    questEditCategoryEdit(id) {
        return this.questEdit(id) + '/category/edit';
    }
    questEditCategoryDelete(id, c_id) {
        return this.questEdit(id) + '/category/delete/' + c_id;
    }
    questEditCategoryOrder(id, l_id) {
        return this.questEdit(id) + '/' + l_id + '/category/order';
    }

    questEditMissionUrl(id, m_id) {
        return this.questEdit(id) + '/mission/edit/' + m_id;
    }
    questEditMissionAdd(id) {
        return this.questEdit(id) + '/mission/add';
    }
    questEditMissionUpdate(id, m_id) {
        return this.questEdit(id) + '/mission/update/' + m_id;
    }
    questEditMissionDelete(id, m_id) {
        return this.questEdit(id) + '/mission/delete/' + m_id;
    }

    questEditMissionFilesUpload(id, m_id) {
        return this.questEdit(id) + '/mission/' + m_id + '/files/upload';
    }
    questEditMissionFilesDelete(id, m_id) {
        return this.questEdit(id) + '/mission/' + m_id + '/files/delete';
    }
    questEditMissionLinksAdd(id, m_id) {
        return this.questEdit(id) + '/mission/' + m_id + '/links/add';
    }
    questEditMissionLinksDelete(id, m_id) {
        return this.questEdit(id) + '/mission/' + m_id + '/links/delete';
    }

    questEditUserDelete(id, u_id) {
        return this.questEdit(id) + '/user/delete/' + u_id;
    }
    questEditUserAdd(id) {
        return this.questEdit(id) + '/user/add';
    }
    questEditUsersPossible(id) {
        return this.questEdit(id) + '/users/possible';
    }

    questSelectMission(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/select';
    }
    questMissionPreview(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/preview';
    }
    questFinishMission(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/finish';
    }
    questOpenWord(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/word';
    }
    questCancelMission(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/cancel';
    }

    questUserFilesUpload(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/files/upload';
    }
    questUserFilesDelete(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/files/delete';
    }

    questUserLinksAdd(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/links/add';
    }
    questUserLinksDelete(id, m_id) {
        return this.quest(id) + '/mission/' + m_id + '/links/delete';
    }

    questSaveUserMission(id, u_id) {
        return this.questRapport(id) + '/user/' + u_id + '/mission/save';
    }
    questAddUserBadge(id, u_id) {
        return this.questRapport(id) + '/user/' + u_id + '/badge/add';
    }
    questDeleteUserBadge(id, u_id, b_id) {
        return this.questRapport(id) + '/user/' + u_id + '/badge/delete/' + b_id;
    }
    questReopenMission(id, u_id) {
        return this.questRapport(id) + '/user/' + u_id + '/mission/reopen';
    }
    questSaveStartScore(id, u_id) {
        return this.questRapport(id) + '/user/' + u_id + '/startscore';
    }

    // magazine
    magazineShow(id) {
        return this.baseUrl() + this.magazine(id);
    }
    magazineArchive() {
        return this.baseUrl() + '/magazine/archive';
    }
    magazineMoveOutArchive(id) {
        return this.baseUrl() + '/magazine/moveoutarchive/' + id;
    }
    magazineSettings(id) {
        return this.baseUrl() + '/magazine/settings/' + id;
    }
    magazineOrder(id) {
        return this.baseUrl() + '/magazine/order/' + id;
    }
    magazineRights(id) {
        return this.baseUrl() + '/magazine/rights/' + id;
    }
    magazineEditors(id) {
        return this.baseUrl() + '/magazine/editors/' + id;
    }
    magazineTemplateArchive(id) {
        return this.baseUrl() + '/magazine/' + id + '/templatearchive';
    }
    magazineLowresPdf(id) {
        return this.baseUrl() + '/magazine/' + id + '/lowrespdf';
    }
    magazineDeleteMultiplePages(id) {
        return this.baseUrl() + '/magazine/deletepages/' + id;
    }
    magazineDeletePages(id) {
        return this.baseUrl() + '/magazine/' + id + '/deletepages';
    }

    magazineSettings(id) {
        return this.baseUrl() + '/magazine/settings/' + id;
    }

    magazineAdminValues(id) {
        return 'magazine/yearbooks/admin/' + id;
    }
    magazineSetRef(id) {
        return 'magazine/' + id + '/ref';
    }

    magazineSendToPress() {
        return 'magazine/yearbooks/send-to-press';
    }

    // plus
    plus() {
        return '/plus';
    }
    plusShow(id) {
        return this.plus() + '/' + id;
    }

    //calendar
    calendarAdd() {
        return 'calendaritem';
    }
    calendarUpdate(id) {
        return 'calendaritem/' + id;
    }
    calendarDelete(id) {
        return 'calendaritem/' + id;
    }

    // assignment
    assignment() {
        return '/assignment';
    }
    assignmentShow(assignment_id, project_id) {
        return this.assignment() + '/' + assignment_id + '/' + project_id;
    }
    assignmentEdit(id, group_id) {
        return this.assignment() + '/edit/' + id + '/' + group_id;
    }
    assignmentDelete(id) {
        return this.assignment() + '/' + id;
    }

    assignmentRubricStore(assignmentId, groupId) {
        return this.assignmentEdit(assignmentId, groupId) + '/rubrics';
    }
    assignmentRubricRemove(assignmentId, groupId) {
        return this.assignmentEdit(assignmentId, groupId) + '/rubrics';
    }
    assignmentRubricUpdate(assignmentId, groupId) {
        return this.assignmentEdit(assignmentId, groupId) + '/rubrics/update';
    }
    assignmentSkillTree(assignmentId, groupId) {
        return this.assignmentEdit(assignmentId, groupId) + '/skill-tree';
    }
    assignmentSkillTreeUpdate(assignmentId, groupId) {
        return this.assignmentEdit(assignmentId, groupId) + '/skill-tree/update';
    }

    assignmentRubricEdit(ARUserId) {
        return this.rubric() + '/assignment/user/' + ARUserId + '/edit';
    }
    assignmentRubricShow(ARUserId) {
        return this.rubric() + '/assignment/user/' + ARUserId + '/show';
    }
    assignmentStatus() {
        return this.assignment() + '/status';
    }
    assignmentStatusSubmit() {
        return this.assignmentStatus() + '/submit';
    }

    rubricAssignmentStatusSubmit() {
        return this.assignment() + '/rubric/submitstatus';
    }
    assignmentStatusCloseAll() {
        return this.assignmentStatus() + '/close-all';
    }
    assignmentStatusClose() {
        return this.assignmentStatus() + '/close';
    }
    assignmentStatusReopen() {
        return this.assignmentStatus() + '/reopen';
    }

    getGroupData(groupId) {
        return this.group() + '/' + groupId + '/group-data/';
    }

    assignmentFeedback() {
        return this.assignment() + '/feedback';
    }
    assignmentFeedbackUpdate(id) {
        return this.assignmentFeedback() + '/' + id;
    }
    assignmentFeedbackRemove(id) {
        return this.assignmentFeedback() + '/' + id;
    }
    assignmentListByGroup(group_id) {
        return this.assignment() + '/listbygroup/' + group_id;
    }

    // assignments
    getGradeableGroupAssignments(group_id) {
        return '/assignments/gradeablebygroup/' + group_id;
    }

    // assignment part
    assignmentPart() {
        return '/assignmentpart';
    }
    assignmentPartUpdate(id) {
        return this.assignmentPart() + '/' + id;
    }
    assignmentPartUpdateFile(id) {
        return this.assignmentPartUpdate(id) + '/file';
    }
    assignmentPartOrder() {
        return this.assignmentPart() + '/order';
    }
    assignmentPartDelete(id) {
        return this.assignmentPart() + '/' + id;
    }
    assignmentPartCopy(id) {
        return this.assignmentPart() + '/copy/' + id;
    }

    assignmentPartEditorBlueprintEdit(id, group_id) {
        return group_id
            ? this.assignmentPart() + '/editor/blueprint/' + id + '?group_id=' + group_id
            : this.assignmentPart() + '/editor/blueprint/' + id;
    }
    assignmentPartEditorBlueprintUpload(id) {
        return this.assignmentPart() + '/editor/blueprint/upload/' + id;
    }

    // assignment part list type
    assignmentPartListOptionAdd(partid) {
        return '/assignmentpartlist/addoption/' + partid;
    }
    assignmentPartListItemAdd(partid) {
        return '/assignmentpartlist/additem/' + partid;
    }
    assignmentPartListOptionUpdate(partid, optionid) {
        return '/assignmentpartlist/updateoption/' + partid + '/' + optionid;
    }
    assignmentPartListOptionDelete(partid, optionid) {
        return '/assignmentpartlist/deleteoption/' + partid + '/' + optionid;
    }
    assignmentPartListItemUpdate(partid, itemid) {
        return '/assignmentpartlist/updateitem/' + partid + '/' + itemid;
    }
    assignmentPartListItemDelete(partid, itemid) {
        return '/assignmentpartlist/deleteitem/' + partid + '/' + itemid;
    }

    assignmentPartFile() {
        return '/assignmentpartfile';
    }
    assignmentPartFileStore(part_id) {
        return this.assignmentPartFile() + '/' + part_id;
    }
    assignmentPartFileDelete(id) {
        return this.assignmentPartFile() + '/' + id;
    }
    assignmentPartAddToProfile() {
        return this.assignmentPart() + '/profile/card';
    }

    assignmentPartFillInTheBlanks(part_id) {
        return this.assignmentPart() + '/' + part_id + '/fill-in-the-blanks';
    }

    assignmentCooperationStore() {
        return this.assignment() + '/cooperation';
    }
    assignmentCooperationUpdate() {
        return this.assignmentCooperationStore() + '/update';
    }
    assignmentCooperationRemove(id) {
        return this.assignmentCooperationStore() + '/' + id;
    }
    assignmentPartnerAutoGenerate(assignment_cooperation_id) {
        return this.assignmentPartner() + '/auto-generate/' + assignment_cooperation_id;
    }
    assignmentPartner() {
        return this.assignment() + '/partner';
    }
    assignmentPartnerStore() {
        return this.assignmentPartner();
    }
    assignmentPartnerUser() {
        return this.assignmentPartner() + '/user';
    }
    assignmentPartnerUserConfirm(id) {
        return this.assignmentPartnerUser() + '/confirm/' + id;
    }
    assignmentPartnerUserDeny(id) {
        return this.assignmentPartnerUser() + '/confirm/' + id;
    }
    assignmentPartnerUserStore() {
        return this.assignmentPartnerUser();
    }
    assignmentPartnerUserRemove(id) {
        return this.assignmentPartnerUser() + '/' + id;
    }
    assignmentPartnerManagerCreate() {
        return this.assignmentPartner() + '/manager/create';
    }
    assignmentPartnerDelete(id) {
        return this.assignmentPartner() + '/' + id;
    }
    assignmentCooperation(assignment_cooperation_id) {
        return this.assignment() + '/cooperation/' + assignment_cooperation_id;
    }
    getAssignmentPartnersForAssignmentCooperation(assignment_cooperation_id) {
        return this.assignmentCooperation(assignment_cooperation_id) + '/assignment-partners';
    }

    addUsersToAssignmentPartner() {
        return this.assignmentPartner() + '/add-users';
    }
    assignmentUpdate(id) {
        return this.assignment() + '/' + id;
    }

    subAssignment() {
        return '/subassignment';
    }
    subAssignmentUpdate(id) {
        return this.subAssignment() + '/' + id;
    }
    subAssignmentDelete(id) {
        return this.subAssignment() + '/' + id;
    }
    subAssignmentOrder() {
        return this.subAssignment() + '/order';
    }

    getDeletedSubAssignments(assignmentId) {
        return this.assignment() + '/' + assignmentId + '/deleted-sub-assignments';
    }
    subAssignmentAssignmentPartner() {
        return this.subAssignment() + '/assignment/partner';
    }
    subAssignmentAssignmentPartnerStore() {
        return this.subAssignmentAssignmentPartner();
    }
    subAssignmentAssignmentPartnerAvailableStudents(project_id, sub_assignment_id) {
        return (
            this.subAssignmentAssignmentPartner() + '/' + project_id + '/' + sub_assignment_id + '/availablestudents'
        );
    }

    subAssignmentDeadline() {
        return this.subAssignment() + '/deadline';
    }
    subAssignmentDeadlineUpdate(id) {
        return this.subAssignmentDeadline() + '/' + id;
    }
    subAssignmentDeadlineRemove(id, group_id) {
        return this.subAssignmentDeadline() + '/' + id + '/' + group_id;
    }

    subAssignmentStatusCloseAll() {
        return this.subAssignmentStatus() + '/close-all';
    }
    subAssignmentStatus() {
        return this.subAssignment() + '/status';
    }
    subAssignmentStatusSubmit() {
        return this.subAssignmentStatus() + '/submit';
    }
    subAssignmentStatusClose() {
        return this.subAssignmentStatus() + '/close';
    }
    subAssignmentStatusReopen() {
        return this.subAssignmentStatus() + '/reopen';
    }

    subAssignmentFeedback() {
        return this.subAssignment() + '/feedback';
    }
    subAssignmentFeedbackUpdate(id) {
        return this.subAssignment() + '/feedback/' + id;
    }
    subAssignmentFeedbackDelete(id) {
        return this.subAssignment() + '/feedback/' + id;
    }

    subAssignmentCooperationStore() {
        return this.subAssignment() + '/cooperation';
    }
    subAssignmentCooperationUpdate() {
        return this.subAssignmentCooperationStore() + '/update';
    }
    subAssignmentCooperationRemove(id) {
        return this.subAssignmentCooperationStore() + '/' + id;
    }

    subAssignmentCopy(id) {
        return this.subAssignment() + '/copy/' + id;
    }

    // assignment part text
    assignmentPartTextUpdate(id) {
        return '/assignmentparttext/' + id;
    }
    assignmentPartVideoLinkUpdate(id) {
        return '/assignmentpartvideolink/' + id;
    }
    assignmentPartTextImageUpload(id) {
        return '/assignmentparttext/' + id + '/image';
    }

    assignmentAnswer() {
        return this.assignment() + '/answer';
    }
    assignmentAnswerUpdate(id) {
        return this.assignmentAnswer() + '/' + id;
    }
    assignmentAnswerEditor(part_id, project_id) {
        return this.assignmentAnswer() + '/' + part_id + '/' + project_id + '/editor/edit';
    }

    assignmentAnswerTextUpdate(id) {
        return this.assignmentAnswer() + '/text/' + id;
    }

    assignmentAnswerJsonUpdate(id) {
        return this.assignmentAnswer() + '/json/' + id;
    }

    assignmentAnswerFiles(id) {
        return this.assignmentAnswerUpdate(id) + '/files';
    }
    assignmentAnswerFileRemove(id) {
        return this.assignmentAnswer() + '/file/' + id;
    }
    assignmentAnswerFileDownload(id) {
        return this.assignmentAnswer() + '/download/' + id;
    }

    assignmentAnswerList() {
        return this.assignmentAnswer() + '/list';
    }
    assignmentAnswerListUpdate(id) {
        return this.assignmentAnswerList() + '/' + id;
    }
    assignmentAnswerListUpdateCheck(id) {
        return this.assignmentAnswerList() + 'check/' + id;
    }

    assignmentDeadline() {
        return this.assignment() + '/deadline';
    }
    assignmentDeadlineUpdate(id) {
        return this.assignmentDeadline() + '/' + id;
    }
    assignmentDeadlineRemove(id, group_id) {
        return this.assignmentDeadline() + '/' + id + '/' + group_id;
    }

    assignmentPublishing() {
        return this.assignment() + '/publishing';
    }
    assignmentUnPublishing() {
        return this.assignment() + '/unpublishing';
    }
    assignmentPublishingRemove(id, group_id) {
        return this.assignmentPublishing() + '/' + id + '/' + group_id;
    }

    assignmentPage() {
        return this.assignment() + '/page';
    }
    assignmentPageUpdate(id) {
        return this.assignment() + '/page/' + id;
    }
    assignmentPageRemove(id) {
        return this.assignmentPage() + '/' + id;
    }
    assignmentPageOrder() {
        return this.assignmentPage() + '/order';
    }

    assignmentSomtodayShareUrl(assignment_uuid, group_uuid) {
        return this.baseUrl() + '/assignment/public?group_uuid=' + group_uuid + '&assignment_uuid=' + assignment_uuid;
    }
    portfolioUpdate(id) {
        return this.portfolio() + '/' + id;
    }

    portfolioCategoryOrder() {
        return '/portfolio/category/order';
    }

    portfolioCategorySchools() {
        return '/portfolio/category/schools';
    }

    portfolioCategoryAssignmentsPublishing(category_id, group_id) {
        return this.portfolio() + '/category/publishings/' + category_id + '/' + group_id;
    }

    copyCategory(category_id) {
        return '/copy/category/' + category_id;
    }
    copyAllCategory(category_id, portfolio_id) {
        return '/copy/category/' + category_id + '/' + portfolio_id;
    }

    portfolioCategoryAssignment() {
        return this.portfolio() + '/category/assignment';
    }
    portfolioCategoryAssignmentOrder() {
        return this.portfolioCategoryAssignment() + '/order';
    }

    portfolioGroupList() {
        return this.portfolio() + '/groups';
    }
    portfolioGroupCategories(group_id) {
        return this.portfolio() + '/group/' + group_id + '/categories';
    }
    portfolioCategoryAssignments(category_id) {
        return this.portfolio() + '/category/' + category_id + '/assignments';
    }
    portfolioCopyAssignment() {
        return this.portfolio() + '/assignment/copy';
    }

    // roadmap
    roadmap() {
        return 'roadmap';
    }
    roadmapSave() {
        return this.roadmap() + '/save';
    }
    roadmapUpdateTitle() {
        return this.roadmap() + '/updatetitle';
    }
    roadmapStepTitle() {
        return this.roadmap() + '/step/title';
    }
    roadmapStepStoreTitle() {
        return this.roadmap() + '/step/store/title';
    }
    roadmapStepDescription() {
        return this.roadmap() + '/step/description';
    }
    roadmapStepDeadline() {
        return this.roadmap() + '/step/deadline';
    }
    roadmapStepDelete(id) {
        return this.roadmap() + '/step/' + id;
    }
    roadmapStepCreate() {
        return this.roadmap() + '/step';
    }
    roadmapStepOrder() {
        return this.roadmap() + '/step/order';
    }
    roadmapProjectToggle(id) {
        return this.roadmap() + '/set/' + id;
    }

    // rating
    rating() {
        return '/rating';
    }
    ratingSave() {
        return this.rating() + '/save';
    }
    ratingDownload(rating_id, project_id) {
        return this.rating() + '/download/' + rating_id + '/' + project_id;
    }

    getRatings(group_id) {
        return this.rating() + '/get/' + group_id;
    }

    ratingEditForm(id, group_id) {
        return this.rating() + '/edit/' + id + '/' + group_id;
    }

    ratingCreateForm(group_id) {
        return this.rating() + '/create/' + group_id;
    }

    ratingDelete(id) {
        return this.rating() + '/' + id;
    }
    ratingDuplicate(id, group_id) {
        return this.rating() + '/copy/' + id + '/' + group_id;
    }
    ratingSectionCreate() {
        return this.rating() + '/section';
    }
    ratingSectionTitle() {
        return this.rating() + '/section/title';
    }
    ratingSectionDescription() {
        return this.rating() + '/section/description';
    }
    ratingSectionPersonal() {
        return this.rating() + '/section/personal';
    }
    ratingSectionType() {
        return this.rating() + '/section/type';
    }
    ratingSectionOrder() {
        return this.rating() + '/section/order';
    }
    ratingItemCreate() {
        return this.rating() + '/item';
    }
    ratingSectionDelete(id) {
        return this.rating() + '/section/delete/' + id;
    }
    ratingItemDelete(id) {
        return this.rating() + '/item/delete/' + id;
    }
    ratingSetResultExplanation(id) {
        return this.rating() + '/setresultexplanation/' + id;
    }
    ratingSetResultPenalty(id) {
        return this.rating() + '/setresultpenalty/' + id;
    }
    ratingSetResultDivide(id) {
        return this.rating() + '/setresultdivide/' + id;
    }
    ratingSetResultPlus(id) {
        return this.rating() + '/setresultplus/' + id;
    }
    ratingSetTitle(id) {
        return this.rating() + '/settitle/' + id;
    }
    ratingItemTitle() {
        return this.rating() + '/item/title';
    }
    ratingItemDescription() {
        return this.rating() + '/item/description';
    }
    ratingItemWeight() {
        return this.rating() + '/item/weight';
    }
    ratingItemMax() {
        return this.rating() + '/item/max';
    }
    ratingItemOrder(id) {
        return this.rating() + '/item/order';
    }
    ratingOptionCreate() {
        return this.rating() + '/option';
    }
    ratingOptionTitle() {
        return this.rating() + '/option/title';
    }
    ratingOptionMax() {
        return this.rating() + '/option/max';
    }
    ratingOptionDelete(id) {
        return this.rating() + '/option/delete/' + id;
    }
    ratingGroupSet(group_rating_id) {
        return this.rating() + '/set/' + group_rating_id;
    }
    ratingGroupAttach(group_id) {
        return this.rating() + '/attach/' + group_id;
    }
    ratingGroupDetach(group_rating_id) {
        return this.rating() + '/detach/' + group_rating_id;
    }
    ratingProjectSave() {
        return this.rating() + '/project/save';
    }

    // questionnaire
    questionnaire() {
        return '/questionnaire';
    }
    questionnaireSave() {
        return this.questionnaire() + '/save';
    }
    questionnaireDelete(id) {
        return this.questionnaire() + '/' + id;
    }
    questionnaireSectionCreate() {
        return this.questionnaire() + '/section';
    }
    questionnaireSectionTitle() {
        return this.questionnaire() + '/section/title';
    }
    questionnaireSectionDescription() {
        return this.questionnaire() + '/section/description';
    }
    questionnaireSectionOrder() {
        return this.questionnaire() + '/section/order';
    }
    questionnaireQuestionCreate() {
        return this.questionnaire() + '/question';
    }
    questionnaireSectionDelete(id) {
        return this.questionnaire() + '/section/delete/' + id;
    }
    questionnaireQuestionDelete(id) {
        return this.questionnaire() + '/question/delete/' + id;
    }
    questionnaireSetTitle(id) {
        return this.questionnaire() + '/settitle/' + id;
    }
    questionnaireQuestionTitle() {
        return this.questionnaire() + '/question/question';
    }
    questionnaireQuestionOrder(id) {
        return this.questionnaire() + '/question/order';
    }
    questionnaireProjectSave() {
        return this.questionnaire() + '/project/save';
    }

    questionnaireProjectToggle(id) {
        return this.questionnaire() + '/set/' + id;
    }

    // magazine
    magazine(id) {
        return '/magazine/' + id;
    }
    magazineDelete(id) {
        return this.magazine(id) + '/delete';
    }
    magazineCopy(id) {
        return this.magazine(id) + '/copy';
    }
    magazineUserDelete(magazine_id, id) {
        return this.magazine(magazine_id) + '/users/delete/' + id;
    }
    magazineUserAdd(magazine_id) {
        return this.magazine(magazine_id) + '/users/add';
    }
    magazineUsersAll(magazine_id) {
        return this.magazine(magazine_id) + '/users/all';
    }
    magazineUpdateRole(magazine_id) {
        return this.magazine(magazine_id) + '/users/role';
    }
    magazineApproveAllPages(magazine_id) {
        return this.magazine(magazine_id) + '/approveallpages';
    }
    magazineAddPages(magazine_id) {
        return this.magazine(magazine_id) + '/addpages';
    }
    magazineReleaseAllPages(magazine_id) {
        return this.magazine(magazine_id) + '/releaseallpages';
    }
    magazineOrderChanged(magazine_id) {
        return this.magazine(magazine_id) + '/order';
    }
    magazinePageDelete(magazine_id, page_id) {
        return this.magazine(magazine_id) + '/page/delete/' + page_id;
    }
    magazineSetPageRight(magazine_id) {
        return this.magazine(magazine_id) + '/setpageright';
    }
    magazinePageRelease(magazine_id) {
        return this.magazine(magazine_id) + '/releasepage';
    }
    magazinePageRestore(magazine_id) {
        return this.magazine(magazine_id) + '/restorepage';
    }
    magazinePageTitle(magazine_id) {
        return this.magazine(magazine_id) + '/title';
    }
    magazineTemplateDelete(magazine_id, id) {
        return this.magazine(magazine_id) + '/template/delete/' + id;
    }
    magazineCheckApprove(magazine_id) {
        return this.magazine(magazine_id) + '/checkapprove';
    }
    magazineYearbookList() {
        return '/magazine/yearbooks';
    }

    yearbookSettings() {
        return this.magazineYearbookList() + '/settings';
    }
    magazineSubmitContactInfo(magazine_id) {
        return this.magazine(magazine_id) + '/contact-info';
    }

    profile() {
        return '/profile';
    }
    profileCard() {
        return this.profile() + '/card';
    }
    profileViewCard(id) {
        return this.profile() + '#card-' + id;
    }
    profileTeacherAccessViewCard(user_id, id) {
        return this.profile() + '/' + user_id + '#card-' + id;
    }
    profileCardUpdate(id) {
        return this.profileCard() + '/' + id;
    }
    profileCardVideoUrl(id) {
        return this.profileCard() + '/' + id + '/url';
    }
    profileCardFiles(id) {
        return this.profileCard() + '/' + id + '/files';
    }
    profileCardFileRemove(id) {
        return this.profileCard() + '/file/' + id;
    }

    profileDownloadPDF(userId) {
        return this.profile() + '/' + userId + '/download-pdf';
    }

    profileAccessStudent() {
        return this.profile() + '/access/student';
    }
    profileAccessStudentRemove(teacher_id, student_id) {
        return this.profile() + '/access/student/' + teacher_id + '/' + student_id;
    }
    profileAccessLasGroup() {
        return this.profile() + '/access/lasgroup';
    }
    profileAccessLasGroupRemove(teacher_id, group_id) {
        return this.profile() + '/access/lasgroup/' + teacher_id + '/' + group_id;
    }
    profileAccessLasMainGroup() {
        return this.profile() + '/access/lasmaingroup';
    }
    profileAccessLasMainGroupRemove(teacher_id, main_gorup_id) {
        return this.profile() + '/access/lasmaingroup/' + teacher_id + '/' + main_gorup_id;
    }

    profilePublicAccess() {
        return this.profile() + '/publicaccess';
    }

    profileAccessAdmin() {
        return this.profile() + '/access/admin';
    }

    profileTeacherAccess(id) {
        return this.profile() + '/progress/' + id;
    }

    profileBannerUpload() {
        return this.profile() + '/uploadbanner';
    }
    profileBannerRemove(id) {
        return this.profile() + '/removebanner/' + id;
    }

    las() {
        return '/las';
    }
    lasAssignStudent(user_id, las_student_id) {
        return this.las() + '/assign/student/' + user_id + '/' + las_student_id;
    }
    lasDetachStudent(las_student_id) {
        return this.las() + '/detach/student/' + las_student_id;
    }
    lasAssignEmployee(user_id, las_employee_id) {
        return this.las() + '/assign/teacher/' + user_id + '/' + las_employee_id;
    }
    lasDetachEmployee(las_employee_id) {
        return this.las() + '/detach/teacher/' + las_employee_id;
    }

    lasImportAll() {
        return this.las() + '/import/all';
    }
    lasImportCurrentSchool() {
        return this.las() + '/import/current-school';
    }

    lasAssignByNameStudent() {
        return this.las() + '/assign/byname/student';
    }
    lasAssignByNameEmployee() {
        return this.las() + '/assign/byname/teacher';
    }

    storeLasLocation() {
        return this.lasLocation() + '/store';
    }
    updateLasLocation() {
        return this.lasLocation() + '/update';
    }
    deleteLasLocation() {
        return this.lasLocation() + '/delete';
    }
    lasLocation() {
        return this.las() + '/location';
    }
    lasLocationSave() {
        return this.lasLocation() + '/save';
    }
    lasLocationChecked() {
        return this.lasLocation() + '/checked';
    }
    lasLocationCreateUsers() {
        return this.lasLocation() + '/users/create';
    }

    lasSomtodayConnectLocationByBrin(brin) {
        return '/las/location/somtoday-connect/get-locations/' + brin;
    }

    lasSomtodayConnect() {
        return this.las() + '/somtodayconnect';
    }
    lasSomtodayConnectAdd() {
        return this.lasSomtodayConnect() + '/add';
    }
    lasSomtodayConnectAddLocations(brin) {
        return this.lasSomtodayConnectAdd() + '/locations?brin=' + brin;
    }
    lasSomtodayConnectAddLocation() {
        return this.lasSomtodayConnectAdd() + '/location';
    }
    managementLas() {
        return '/management/las';
    }
    lasImportDetails(importId) {
        return this.managementLas() + '/import/' + importId;
    }
    adminLas() {
        return '/admin/las';
    }
    adminLasImportDetails(id) {
        return this.adminLas() + '/import/' + id;
    }
    //digistudies
    digitalstudies() {
        return '/videos';
    }
    digitalstudiesGetDomains(discipline_id) {
        return this.digitalstudies() + '/domain/' + discipline_id;
    }
    digitalstudiesGetDomainsVideoList(domain_id) {
        return this.digitalstudies() + '/video/list/' + domain_id;
    }
    digistudiesVideo(id) {
        return this.digitalstudies() + '/discipline/' + id;
    }

    //conference
    conferenceGetPossibleUsers(conference_id) {
        return '/conference/getusers/' + conference_id;
    }
    conferenceCheckPublicOnline(hash) {
        return '/conference/public/share/' + hash + '/check';
    }
    conferenceJoinPublicOnline(hash) {
        return '/conference/public/share/' + hash + '/join';
    }

    //bank
    assignmentGetCategoriesByCourse(course_id) {
        return '/ab/categories/bycourse/' + course_id;
    }

    getabAssignmentsByCourse() {
        return '/ab/bycourse';
    }
    portfolioSaveAbAssignment() {
        return '/portfolio/category/abassignment';
    }

    //Organization
    organizationSave() {
        return '/organization';
    }
    organizationUpdate(organization_id) {
        return `/organization/${organization_id}`;
    }
    organizationRemove(organization_id) {
        return `/organization/${organization_id}`;
    }
    organizationAssignmentCreate() {
        return '/organization/assignment';
    }
    organizationAssignmentFolderCreate(organization_id) {
        return `organization/${organization_id}/assignment/folder`;
    }
    organizationAssignmentFolderUpdate(folder_id) {
        return `organization/assignment/folder/${folder_id}`;
    }
    organizationAssignmentFolderRemove(folder_id) {
        return `organization/assignment/folder/${folder_id}`;
    }
    organizationAssignmentRemove(assignment_id) {
        return `organization/assignment/${assignment_id}`;
    }
    organizationAssignmentUpdate(assignment_id) {
        return `organization/assignment/${assignment_id}`;
    }

    organizationSettings(organization_id) {
        return '/organization/settings/' + organization_id;
    }
    organizationGeneralStore() {
        return 'organization/general/update';
    }
    organizationUserDelete(organization_id) {
        return '/organization/user/delete/' + organization_id;
    }
    organizationUserAdd(organization_id) {
        return 'organization/user/add/' + organization_id;
    }
    organizationUserUpdate(id) {
        return 'organization/user/update/' + id;
    }

    // education levels
    educationLevels() {
        return '/education_levels';
    }

    // course ab_categories
    coursesAndAbCategories() {
        return '/course/ab_category';
    }

    // ab assignment
    abAssignment() {
        return '/ab/assignment';
    }
    abAssignmentRemove(id) {
        return this.abAssignment() + '/' + id;
    }

    //user account
    accountUpdate() {
        return '/account/update';
    }
    accountPasswordSubmit() {
        return 'account/password';
    }
    userSettings() {
        return 'account/settings';
    }
    setUserLocale(locale) {
        return '/user/set-locale/' + locale;
    }

    // PersonalGoals
    personalGoal() {
        return '/personalgoal';
    }
    personalGoalUpdate(personal_goal_id) {
        return 'personalgoal/' + personal_goal_id;
    }
    personalGoalRemove(personal_goal_id) {
        return 'personalgoal/' + personal_goal_id;
    }
    personalGoalArchive(personal_goal_id) {
        return 'personalgoal/archive/' + personal_goal_id;
    }
    personalGoalUnArchive(personal_goal_id) {
        return 'personalgoal/unarchive/' + personal_goal_id;
    }

    personalGoals() {
        return '/personalgoals';
    }
    personalGoalsStudent(user_id) {
        return '/personalgoals/' + user_id;
    }

    personalGoalTaskUpdate(personal_goal_task_id) {
        return 'personalgoal/' + personal_goal_task_id + '/tasks';
    }
    personalGoalTaskRemove(personal_goal_task_id, task_id) {
        return 'personalgoal/' + personal_goal_task_id + '/task/' + task_id;
    }
    personalGoalTaskAdd(personal_goal_task_id) {
        return 'personalgoal/' + personal_goal_task_id + '/task/add';
    }
    personalGoalTaskStatusSubmit(personal_goal_task_id) {
        return 'personalgoal/task/' + personal_goal_task_id;
    }
    personalGoalTaskStatusUpdate(personal_goal_task_id) {
        return 'personalgoal/task/' + personal_goal_task_id + '/update';
    }
    getSkillsForPersonalGoal() {
        return 'personalgoal/' + 'skills';
    }
    addPersonalGoalBadge(id) {
        return this.personalGoal() + '/' + id + '/badge';
    }

    // vso style related
    vsoStylePersonalGoals() {
        return this.personalGoals() + '/vso';
    }
    storeDualPersonalGoal() {
        return this.vsoStylePersonalGoals() + '/submit-dual';
    }
    vsoStylegradableMoment() {
        return this.vsoStylePersonalGoals() + '/submit-gradable-moment';
    }
    submitVsoStyleStudentEvaluation() {
        return this.vsoStylePersonalGoals() + '/submit-student-evaluation';
    }
    updateVsoStyleStudentEvaluation() {
        return this.vsoStylePersonalGoals() + '/update-student-evaluation';
    }

    // Britannica
    britannica(id) {
        return '/britannica/' + id;
    }

    // Exams
    exams() {
        return '/exams';
    }
    practiceExams() {
        return '/exams/practice';
    }

    // Databank
    databank() {
        return '/ab/assignments';
    }

    // Admin routes

    schools() {
        return '/school';
    }
    selectSchool(school_id) {
        return '/school/select/' + school_id;
    }
    defaultSkills() {
        return '/default/skills/index';
    }
    accounts() {
        return '/accounts';
    }
    accountsGetAll() {
        return '/accounts/getall';
    }
    organizations() {
        return '/organization';
    }
    magazines() {
        return '/magazine/magazines';
    }
    yearbooks() {
        return '/magazine/yearbooks';
    }
    afscheidsboekjes() {
        return '/magazine/afscheidsboekjes';
    }
    templates() {
        return '/template';
    }
    images() {
        return '/image';
    }
    lists() {
        return '/lists';
    }
    orders() {
        return '/admin-payments';
    }

    deadlines() {
        return '/deadlines';
    }
    deadline() {
        return '/deadline';
    }
    deadlineUpdate(deadline_id) {
        return '/deadline/' + deadline_id;
    }
    deadlineDelete(deadline_id) {
        return '/deadline/' + deadline_id;
    }

    adminAccounts() {
        return 'admin/accounts';
    }
    adminAccountDelete(user_id) {
        return 'admin/accounts/' + user_id;
    }
    adminAccountAdd() {
        return 'admin/accounts/add';
    }
    adminAccountUpdate(user_id) {
        return 'admin/accounts/' + user_id;
    }

    portfolioDownloadAnswers(groupId) {
        return `/group/${groupId}/portfolio/answers/export`;
    }

    //parent register
    customFormSubmit(id) {
        return 'customform/' + id;
    }
    customFormFinished() {
        return '/customform/finished';
    }

    // Files
    projectFilesCreate(projectId) {
        return '/files/create/' + projectId;
    }

    // Plagiarism reports
    requestPlagiarismReportForProjectFile(fileId) {
        return 'plagiarism-report/project-file/' + fileId + '/request';
    }
    requestPlagiarismReportForAssignmentAnswerFile(assignmentAnswerFileId) {
        return 'plagiarism-report/assignment-answer-file/' + assignmentAnswerFileId + '/request';
    }
    requestPlagiarismReportForAssignmentAnswerEditor(assignmentAnswerId) {
        return 'plagiarism-report/assignment-answer-editor-file/' + assignmentAnswerId + '/request';
    }
    requestPlagiarismReportForPaperEditorFile(projectId) {
        return 'plagiarism-report/paper-editor-file/' + projectId + '/request';
    }

    requestPlagiarismReportForEditorFile(editorFileId) {
        return 'plagiarism-report/editor-file/' + editorFileId + '/request';
    }

    getPlagiarismReportsForProjectFile(fileId) {
        return 'plagiarism-report/project-file/' + fileId;
    }
    getPlagiarismReportsForAssignmentAnswerEditor(assignmentAnswerId) {
        return 'plagiarism-report/assignment-answer-editor-file/' + assignmentAnswerId;
    }
    getPlagiarismReportsForAssignmentAnswerFile(assignmentAnswerFileId) {
        return 'plagiarism-report/assignment-answer-file/' + assignmentAnswerFileId;
    }
    getPlagiarismReportsForPaperEditorFile(projectId) {
        return 'plagiarism-report/paper-editor-file/' + projectId;
    }

    getPlagiarismReportsForEditorFile(editorFileId) {
        return 'plagiarism-report/editor-file/' + editorFileId;
    }

    // PWS
    pws() {
        return '/profile_paper';
    }

    // Pixabay
    pixabay() {
        return '/pixabay';
    }
    pixabayImages() {
        return '/pixabay/images';
    }

    //Socie mobile app
    socieApp() {
        return 'app';
    }

    //Help
    helpImproveUs() {
        return 'help/improve';
    }

    //Internships
    internship() {
        return '/management/internships';
    }
    internshipFind(id) {
        return this.internship() + '/' + id;
    }
    internshipUpdate(id) {
        return this.internship() + '/' + id;
    }
    internshipDelete(id) {
        return this.internship() + '/' + id;
    }
    internshipCreate() {
        return this.internship() + '/create';
    }
    internshipEdit(id) {
        return this.internship() + '/edit/' + id;
    }
    internshipUpdateTags(id) {
        return this.internship() + '/updateTags/' + id;
    }
    internshipStudentsForInternshipGet(id) {
        return this.internship() + '/students/' + id;
    }
    internshipDeleteStudent(userId, internshipId) {
        return this.internship() + '/' + internshipId + '/signoutstudent/' + userId;
    }
    internshipAddStudent(userId) {
        return this.internship() + '/signupstudent/' + userId;
    }
    internshipCheckStudents(internshipId) {
        return this.internshipFind(internshipId) + '/checkstudents';
    }

    internshipAcceptExternal(internshipId) {
        return this.internship() + '/' + internshipId + '/accept';
    }
    internshipArchiveExternal(internshipId) {
        return this.internship() + '/' + internshipId + '/archive';
    }

    internshipAcceptPersonal() {
        return this.internship() + '/personal/accept';
    }
    internshipTag() {
        return this.internship() + '/tags';
    }
    internshipTagGroupCheck(id) {
        return this.internshipTag() + '/' + id + '/checkgroups';
    }
    internshipTagUpdate(id) {
        return this.internshipTag() + '/' + id;
    }
    internshipTagCheckStudents(tagId) {
        return this.internshipTag() + '/' + tagId + '/checkstudents';
    }
    internshipTagDelete(id) {
        return this.internshipTag() + '/' + id;
    }

    internshipManagement() {
        return this.internship() + '/management';
    }
    internshipManagementGetTeachers() {
        return this.internshipManagement() + '/getallteachers';
    }

    // internshipSettings() { return this.internship() + '/settings'}
    internshipDatabase() {
        return '/internshipDatabase';
    }
    internshipDatabaseCreate() {
        return this.internshipDatabase() + '/create';
    }
    internshipDatabaseDelete(id) {
        return this.internshipDatabase() + '/delete/' + id;
    }
    internshipDatabaseEdit(id) {
        return this.internshipDatabase() + '/edit/' + id;
    }

    internshipDurationTagCreate() {
        return this.internshipDatabase() + '/durationtag/create';
    }
    internshipDurationTagUpdate(id) {
        return this.internshipDatabase() + '/durationtag/update/' + id;
    }
    internshipDurationTagDelete(id) {
        return this.internshipDatabase() + '/durationtag/delete/' + id;
    }
    studentInternship() {
        return '/internship';
    }
    studentInternshipShow(id) {
        return this.studentInternship() + '/' + id;
    }

    studentInternshipIndex() {
        return this.studentInternship();
    }
    studentInternshipSignup() {
        return this.studentInternship() + '/signup';
    }

    studentPersonalInternships() {
        return this.studentInternship() + '/personal';
    }

    studentPersonalInternshipCreate() {
        return this.studentPersonalInternships() + '/create';
    }

    studentPersonalInternshipEdit(internshipId) {
        return this.studentPersonalInternships() + '/edit/' + internshipId;
    }

    studentPersonalInternshipDelete(internshipId) {
        return this.studentPersonalInternships() + '/' + internshipId;
    }

    studentPersonalInternshipsFetch() {
        return this.studentPersonalInternships() + '/fetch';
    }
    studentInternshipSignout(projectId) {
        return this.studentInternship() + '/signout/' + projectId;
    }
    studentSignedInternshipAgreementUpload(internshipId) {
        return this.studentInternship() + '/signedAgreement/' + internshipId;
    }

    studentSignedInternshipAgreementDelete(signedInternshipAgreementId) {
        return this.studentInternship() + '/signedAgreement/' + signedInternshipAgreementId;
    }
    studentSignedInternshipAgreementChangeName(internshipId) {
        return this.studentInternship() + '/signedAgreement/change/name/' + internshipId;
    }

    getAllInternshipTags() {
        return this.internshipTag() + '/fetchAll/';
    }
    internshipCopyToDatabase(internshipId) {
        return this.internship() + '/copy-personal/' + internshipId;
    }

    managementOrganizations() {
        return '/management/organizations';
    }
    managementDeleteOrganization(organizationId) {
        return this.managementOrganizations() + '/' + organizationId;
    }
    managementOrganizationsGet() {
        return this.managementOrganizations() + '/get';
    }
    managementOrganizationsAdd(orgId) {
        return this.managementOrganizations() + '/' + orgId;
    }

    externalInternship() {
        return '/external/organization/internships';
    }
    externalInternshipCreate() {
        return this.externalInternship() + '/create';
    }
    externalInternshipUpdate(id) {
        return this.externalInternship() + '/' + id;
    }
    externalInternshipDelete(id) {
        return this.externalInternship() + '/' + id;
    }
    externalInternshipEdit(id) {
        return this.externalInternship() + '/edit/' + id;
    }

    groupInternship() {
        return '/internship/group';
    }

    groupInternships(groupId) {
        return this.groupInternship() + '/' + groupId;
    }

    groupGetInternshipsForSchool() {
        return this.groupInternship() + '/getInternships';
    }
    groupInternshipAddToGroup(groupId) {
        return this.groupInternship() + '/' + groupId + '/save';
    }

    excludeInternshipFromGroup(groupId) {
        return this.groupInternships(groupId) + '/exclude';
    }

    uploadInternshipAgreement(groupId) {
        return this.groupInternship() + '/' + groupId + '/internshipAgreement';
    }

    projectInternshipShow(projectId) {
        return this.studentInternship() + '/' + projectId;
    }

    internshipAcceptStudent() {
        return this.groupInternship() + '/acceptstudent';
    }
    internshipRejectStudent() {
        return this.groupInternship() + '/rejectstudent';
    }
    updateinternship(internshipId) {
        return this.groupInternship() + '/update/' + internshipId;
    }

    // learning path management
    managementLearningPath() {
        return '/management/learning-path';
    }
    lpSettings() {
        return this.managementLearningPath() + '/category/settings';
    }
    createLpCategory() {
        return this.managementLearningPath() + '/category/create';
    }
    updateLpCategory(id) {
        return this.managementLearningPath() + '/category/update/' + id;
    }
    removeLpCategory(id) {
        return this.managementLearningPath() + '/category/' + id;
    }
    LpCategoryAssignments(id) {
        return this.managementLearningPath() + '/assignments/' + id;
    }
    createLpAssignment(categoryId) {
        return this.managementLearningPath() + '/assignments/' + categoryId + '/create';
    }
    updateLpAssignment(id) {
        return this.managementLearningPath() + '/assignments/update/' + id;
    }
    removeLpAssignment(id) {
        return this.managementLearningPath() + '/assignments/' + id;
    }
    createDeadlineSeries() {
        return this.managementLearningPath() + '/deadlineSeries/create';
    }
    updateDeadlineSeries(id) {
        return this.managementLearningPath() + '/deadlineSeries/update/' + id;
    }
    removeLpDeadlineSeries(id) {
        return this.managementLearningPath() + '/deadlineSeries/' + id;
    }
    LpDeadlineSeries(id) {
        return this.managementLearningPath() + '/deadlineSeries/deadlines/' + id;
    }
    createLpDeadline() {
        return this.managementLearningPath() + '/deadlineSeries/deadlines/create';
    }
    updateLpDeadline() {
        return this.managementLearningPath() + '/deadlineSeries/deadlines/update';
    }
    removeLpDeadline(id) {
        return this.managementLearningPath() + '/deadlineSeries/deadlines/' + id;
    }
    lpManagementDeadline(deadlineSeriesId, id) {
        return this.LpDeadlineSeries(deadlineSeriesId) + '/students/' + id;
    }
    lpDeadlineRemoveStudentAssignment(deadlineSeriesId, deadlineId, studentId, assignmentId) {
        return this.lpManagementDeadline(deadlineSeriesId, deadlineId) + '/remove/' + studentId + '/' + assignmentId;
    }
    lpManagementAssignmentSignUp(deadlineSeriesId, deadlineId) {
        return this.lpManagementDeadline(deadlineSeriesId, deadlineId) + '/add';
    }

    // learning path student
    learningPath() {
        return '/learning-path';
    }
    lpDeadline(id) {
        return this.learningPath() + '/deadline/' + id;
    }
    lpCategory(deadlineId, categoryId) {
        return this.lpDeadline(deadlineId) + '/category/' + categoryId;
    }
    lpAssignmentSignUp() {
        return this.learningPath() + '/assignments/signup';
    }
    lpRemoveSignupRecord(id) {
        return this.learningPath() + '/assignments/signout/' + id;
    }

    workflow() {
        return '/workflow';
    }
    workflowDetail(id) {
        return this.workflow() + '/' + id;
    }

    // SLU Dashboard
    sluDashboard() {
        return '/slu-dashboard';
    }
    sluCourses() {
        return this.sluDashboard() + '/courses';
    }
    sluCourse(id) {
        return this.sluDashboard() + '/course/' + id;
    }

    sluCourseBanner(sluCourseId) {
        return this.sluCourse(sluCourseId) + '/banner';
    }
    sluCohort(sluCourseId) {
        return this.sluCourse(sluCourseId) + '/cohort';
    }
    sluCohortUpdate(sluCourseId) {
        return this.sluCohort(sluCourseId) + '/update';
    }
    sluCohortGet(sluCourseId, sluCohortId) {
        return this.sluCohort(sluCourseId) + '/' + sluCohortId;
    }
    sluCohortAddLasGroup(sluCourseId, sluCohortId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/addGroup';
    }
    sluCohortDeleteLasGroup(sluCourseId, sluCohortId, type, id) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/delete/' + type + '/' + id;
    }
    sluModule(sluCourseId, sluCohortId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/store';
    }

    sluGetSomTodayConnectTests(sluCourseId, sluCohortId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/somTodayConnectTests';
    }
    sluGetSomTodayConnectCourseUuids(sluCourseId, sluCohortId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/somTodayConnectVakUuids';
    }
    sluModuleUpdate(sluCourseId, sluCohortId, sluModuleId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/update/' + sluModuleId;
    }

    sluCohortCopy() {
        return this.sluDashboard() + '/copy-cohort';
    }
    sluModuleCopy() {
        return this.sluDashboard() + '/copy-module';
    }
    sluModuleDelete(sluCourseId, sluCohortId, sluModuleId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/delete/' + sluModuleId;
    }
    sluModuleGet(sluCourseId, sluCohortId, sluModuleId) {
        return this.sluCohortGet(sluCourseId, sluCohortId) + '/module/' + sluModuleId;
    }
    sluCohortsForCopy(sluCourseId) {
        return this.sluCohort(sluCourseId) + '/forCopy';
    }
    sluStudentBoard(userId) {
        return this.sluDashboard() + '/student/' + userId;
    }
    sluStudentCourse(userId, sluCourseId) {
        return this.sluStudentBoard(userId) + '/course/' + sluCourseId;
    }
    sluStatusTags() {
        return this.sluDashboard() + '/statusTag';
    }
    sluStatusTagsUpdate(sluStatusTagId) {
        return this.sluStatusTags() + '/update/' + sluStatusTagId;
    }
    sluStatusTagsDelete(sluStatusTagId) {
        return this.sluStatusTags() + '/delete/' + sluStatusTagId;
    }

    sluLabels() {
        return this.sluDashboard() + '/label';
    }
    sluLabelsUpdate(sluLabelId) {
        return this.sluLabels() + '/update/' + sluLabelId;
    }
    sluLabelsDelete(sluLabelId) {
        return this.sluLabels() + '/delete/' + sluLabelId;
    }

    sluStatusTagUncompleted() {
        return this.sluStatusTags() + '/uncompleted';
    }
    sluModuleRecord() {
        return this.sluDashboard() + '/updateModuleRecord';
    }
    sluSchoolSettings() {
        return this.sluDashboard() + '/schoolSettings';
    }
    sluGetTeachers() {
        return this.sluSchoolSettings() + '/get-teachers';
    }
    sluManagement() {
        return this.sluSchoolSettings() + '/management';
    }

    studentSluDashboard() {
        return '/student-slu-dashboard';
    }
    studentSluCourse(sluCourseId) {
        return this.studentSluDashboard() + '/course/' + sluCourseId;
    }

    // teams
    teamsRedirect(params) {
        return this.baseUrl() + '/teams-app/redirect' + this.createParams(params);
    }
    teamsPortfolioConfigStore() {
        return 'teams-app/config/portfolio';
    }

    // AFAQ
    adminAFAQ() {
        return this.baseUrl() + '/admin/AFAQ';
    }
    AdminAfaqImage(id) {
        return this.adminAFAQ() + '/' + id + '/image';
    }
    AdminAfaqTags() {
        return this.adminAFAQ() + '/tags';
    }
    afaqTagsUpdate(id) {
        return this.AdminAfaqTags() + '/update/' + id;
    }
    afaqTagsDelete(id) {
        return this.AdminAfaqTags() + '/delete/' + id;
    }
    adminAfaqCategory() {
        return this.adminAFAQ() + '/categories';
    }
    updateAfaqCategory() {
        return this.adminAfaqCategory() + '/update';
    }
    afaqCategoryOrder() {
        return this.adminAfaqCategory() + '/order';
    }
    afaqCategoryQuestion(categoryId) {
        return this.adminAfaqCategory() + '/' + categoryId + '/question';
    }
    afaqCategoryQuestionOrder(categoryId) {
        return this.afaqCategoryQuestion(categoryId) + '/order';
    }
    afaqCategoryQuestionUpdate(categoryId) {
        return this.afaqCategoryQuestion(categoryId) + '/update';
    }

    // Assignments tags
    assignmentsTagsUpdate(group_id) {
        return this.group() + '/assignment-tags/' + group_id;
    }
    getassignmentTags(group_id) {
        return this.group() + '/assignment-tags/' + group_id;
    }
    storeAssignmentTag(assignment_id) {
        return '/assignment-tag/' + assignment_id;
    }

    notifications() {
        return '/notifications';
    }
    notificationRead(notification_id) {
        return '/notification/markasread/' + notification_id;
    }

    // Badges
    adminBadges() {
        return '/admin/badges';
    }
    getBadges() {
        return '/badges';
    }
    addAdminBadges() {
        return this.adminBadges() + '/add';
    }
    removeAdminBadge(id) {
        return this.adminBadges() + '/' + id + '/remove';
    }

    // Project types
    adminProjectTypes() {
        return '/admin/project-types';
    }

    createParams(params) {
        let paramString = '';
        let count = 0;
        for (const key in params) {
            if (count === 0) {
                paramString += '?' + key + '=' + params[key];
            } else {
                paramString += '&' + key + '=' + params[key];
            }
            count++;
        }
        return paramString;
    }

    // part of an idea to have periods cross multiple modules like modules and learning path, and be manageble in a seperate place.
    managePeriods() {
        return '/management/periods';
    }
    managePeriodsDelete(id) {
        return this.managePeriods() + '/' + id;
    }
    managePeriodsUpdate(id) {
        return this.managePeriods() + '/' + id;
    }

    // Test Center
    testCenterTeacher() {
        return '/students/test-center';
    }

    testIssuings() {
        return this.testCenterTeacher() + '/issuing';
    }
    testIssuing(id) {
        return this.testIssuings() + '/' + id;
    }
    testIssuingDelete(id) {
        return this.testIssuing(id);
    }
    testIssuingShow(id) {
        return this.testIssuing(id);
    }
    testIssuingWizardShow(id) {
        return this.testCenterTeacher() + '/issuing';
    }
    issueTestLas() {
        return this.testIssuings() + '/las';
    }
    issueTestToStudents() {
        return this.testIssuings() + '/students';
    }
    testIssuingSubmitTeachers(id) {
        return this.testIssuing(id) + '/update-teachers';
    }

    testCenter() {
        return '/test-center';
    }
    testResponse(responseId) {
        return this.testCenter() + '/response/' + responseId;
    }
    testResponseAnswer(responseId, questionId) {
        return this.testResponse(responseId) + '/question/' + questionId + '/submit-answer';
    }
    testResponseSubmit(responseId) {
        return this.testResponse(responseId) + '/submit';
    }
    testResponseResult(responseId) {
        return this.testResponse(responseId) + '/result';
    }

    getNextTestQuestion(responseId, sortOrder) {
        return this.testResponse(responseId) + '/question/next';
    }
    getTestQuestion(responseId, sortOrder) {
        return this.testResponse(responseId) + '/question/' + sortOrder;
    }

    //Las group overview
    lasGroupOverview() {
        return '/students/las-groups';
    }
    getLasMainGroupInfo(lasMainGroupId) {
        return this.lasGroupOverview() + '/las-main-group/' + lasMainGroupId;
    }
    getLasGroupInfo(lasGroupId) {
        return this.lasGroupOverview() + '/las-group/' + lasGroupId;
    }
    // Common
    getStudents() {
        return '/get-students';
    }
    getTeachers() {
        return '/get-teachers';
    }

    // Creathlon
    creathlon() {
        return '/creathlon';
    }
    creathlonShow(id) {
        return this.creathlon() + '/' + id;
    }

    lessonModules() {
        return '/external/organization/lesson-modules/';
    }
    lessonModuleStore() {
        return this.lessonModules() + 'store';
    }
    lessonModuleUpdate(lesson_module_id) {
        return this.lessonModules() + lesson_module_id + '/update/';
    }
    lessonModuleCopy(lesson_module_id) {
        return this.lessonModules() + lesson_module_id + '/copy/';
    }
    lessonModuleDelete(lesson_module_id) {
        return this.lessonModules() + lesson_module_id + '/delete/';
    }
    lessonModuleShow(lesson_module_id) {
        return this.lessonModules() + lesson_module_id;
    }

    lessonModuleTypes() {
        return this.lessonModules() + 'types';
    }
    updateLessonOrder() {
        return '/lessons/order';
    }
    lessonManualLessonStore() {
        return '/lessons/store';
    }
    lessonManualLessonUpdate(lesson_id) {
        return '/lessons/' + lesson_id + '/update';
    }
    lessonManualLessonDelete(lesson_id) {
        return '/lessons/' + lesson_id + '/delete/';
    }

    storeLessonGoal(lesson_id) {
        return '/lessons/' + lesson_id + '/store-goal';
    }

    updateLessonGoal(lesson_id, goal_id) {
        return '/lessons/' + lesson_id + '/update-goal/' + goal_id;
    }

    updateCoreLessonGoal(lesson_id) {
        return '/lessons/' + lesson_id + '/update-core-goal';
    }

    deleteLessonGoal(lesson_id, goal_id) {
        return '/lessons/' + lesson_id + '/delete-goal/' + goal_id;
    }

    updateGoalOrder(lesson_id) {
        return '/lessons/' + lesson_id + '/goal-order';
    }

    storeCustomGoalList(lesson_id) {
        return '/lessons/' + lesson_id + '/custom-goal-list';
    }

    updateCustomGoalList(lesson_id, custom_goal_list_id){
        return '/lessons/' + lesson_id + '/custom-goal-list/' + custom_goal_list_id + '/update';
    }

    deleteCustomGoalList(lesson_id, custom_goal_list_id){
        return '/lessons/' + lesson_id + '/custom-goal-list/' + custom_goal_list_id + '/delete';
    }

    updateCustomGoalListOrder(lesson_id) {
        return '/lessons/' + lesson_id + '/custom-goal-list/order';
    }

    storeCustomLessonGoal(lesson_id, custom_goal_list_id) {
        return '/lessons/' + lesson_id + '/custom-goal-list/' + custom_goal_list_id + '/goal';
    }

    updateCustomGoalOrder(lesson_id, custom_goal_list_id) {
        return '/lessons/' + lesson_id + '/custom-goal-list/' + custom_goal_list_id + '/goal/order';
    }

    lessonFileUpload(lesson_id) {
        return '/lessons/' + lesson_id + '/file-upload';
    }
    deleteLessonFile(lesson_id, file_id) {
        return '/lessons/' + lesson_id + '/file/' + file_id;
    }

    updateTextBlockOrder(lesson_id) {
        return '/lessons/' + lesson_id + '/text-block-order';
    }

    storeLessonTextBlock(lesson_id) {
        return '/lessons/' + lesson_id + '/text-block/store';
    }

    updateLessonTextBlock(lesson_id, text_block_id) {
        return '/lessons/' + lesson_id + '/text-block/' + text_block_id + '/update';
    }

    deleteLessonTextBlock(lesson_id, text_block_id) {
        return '/lessons/' + lesson_id + '/text-block/' + text_block_id + '/delete';
    }

    lessonManualStoreSlide(lesson_id, text_block_id) {
        return '/lessons/' + lesson_id + '/text-block/' + text_block_id + '/slide/store';
    }

    lessonManualUpdateSlide(lesson_id, text_block_id, slide_id) {
        return '/lessons/' + lesson_id + '/text-block/' + text_block_id + '/slide/' + slide_id;
    }

    newPortfolioCategory(portfolio_id) {
        return '/portfolio/edit/' + portfolio_id + '/category/store';
    }

    newPortfolioCategoryUpdate(portfolio_id, category_id) {
        return '/portfolio/edit/' + portfolio_id + '/category/' + category_id + '/update';
    }

    newPortfolioCategoryDelete(portfolio_id, category_id) {
        return '/portfolio/edit/' + portfolio_id + '/category/' + category_id + '/delete';
    }

    newAssignmentStore(portfolio_id, category_id) {
        return '/portfolio/edit/' + portfolio_id + '/category/' + category_id + '/assignment/store';
    }

    newCopyAssignment(portfolio_id, category_id) {
        return '/portfolio/edit/' + portfolio_id + '/category/' + category_id + '/assignment/copy';
    }

    subAssignmentRestore(assignmentId) {
        return '/assignment/edit/' + assignmentId + '/restore-sub-assignment/';
    }

    organizationAssignment(lessonModuleId, assignmentId) {
        return this.lessonModuleShow(lessonModuleId) + '/assignment/' + assignmentId;
    }

    getLessonModules(organization_id) {
        return '/lesson-modules/organization/' + organization_id;
    }

    getLessonModulesForSchool() {
        return '/lesson-modules/school';
    }

    getLessonsForAssignment(assignment_id) {
        return '/assignment/' + assignment_id + '/get-lessons';
    }

    setLessonForAssignment(assignment_id) {
        return '/assignment/' + assignment_id + '/set-lesson';
    }

    adminCopyGroups() {
        return '/admin/copy-groups';
    }

    lessonDeleteSlide(lesson_id, text_block_id, slide_id) {
        return '/lessons/' + lesson_id + '/text-block/' + text_block_id + '/slide/' + slide_id + '/delete';
    }

    lessonSlideOrder(lesson_id) {
        return '/lessons/' + lesson_id + '/slide-order';
    }

    lessonManualLessonShowSlidesAtSlide(lesson_id, slide_id) {
        return '/lessons/' + lesson_id + '/show-slides/' + slide_id;
    }

    lessonManualLessonShowSlides(lesson_id) {
        return '/lessons/' + lesson_id + '/show-slides/';
    }

    lessonModuleSchool() {
        return 'external/organization/schools/sync';
    }

    magazineParentPageUpdate(magazine_id, magazine_uuid) {
        return '/magazine/' + magazine_id + '/parent-page/' + magazine_uuid;
    }

    getMagazineParentPage(magazine_id, magazine_uuid) {
        return '/magazine/' + magazine_id + '/parent-page/' + magazine_uuid + '/get-parent-page';
    }

    magazineParentPageFinalize(magazine_id, magazine_uuid) {
        return '/magazine/' + magazine_id + '/parent-page/' + magazine_uuid + '/finalize';
    }

    magazineParentPageEdit(magazine_id, magazine_uuid, parentPageKey) {
        return '/magazine/' + magazine_id + '/parent-page/' + magazine_uuid + '/' + parentPageKey;
    }

    magazineParentPageOverview(magazine_id) {
        //for some reason the '/magazine/' already gets added by the blade!?
        return magazine_id + '/parent-page-overview';
    }
    magazineParentPageDeadlineUpdate(magazine_id) {
        return 'magazine/' + magazine_id + '/parent-page-update-deadline';
    }

    magazinePageApprove() {
        return '/designer/page/approve';
    }

    adminAnalytics() {
        return '/admin/analytics';
    }
    getAnalyticsTagsAndEducationLevels() {
        return '/admin/analytics/tags-and-education-levels'
    }

    analyticsTags() {
        return '/admin/analytics/tags';
    }

    updateAnalyticsData() {
        return '/admin/analytics/update-group';
    }

    adminAnalyticsSchool(school_id) {
        return this.adminAnalytics() + '/school/' + school_id;
    }

    adminGoToGroup(group_id) {
        return '/admin/group/' + group_id
    }
}

export const routes = new Routes();
